export default __webpack_public_path__ + "static/carrefour-ac348b3f219abfbe1db2465738c3aaf6.png";